<template>
  <div id="new-client" class="content">
    <div class="section-title">
      <div class="row">
        <div class="col-md-7">
          <h3>{{ title }}</h3>
        </div>
        <div class="col-md-5">
          <div class="userLog_bread">
            <span v-if="userLogged">
              {{
                userLogged.comercialName
                  ? userLogged.comercialName
                  : userLogged.name + " " + userLogged.lastName
              }}
            </span>
          </div>
        </div>
      </div>
      <hr />
    </div>
    <div id="offers">
      <div
        class="block"
        style="margin-top: 50px"
        v-if="offers && offers.length > 0"
      >
        <div class="row mb-1">
          <div class="col-md-6">
            <!-- Botón de 'Calculadora' -->
            <div class="calculator-modal-button" @click="openCalculatorModal()">
              <img
                width="25"
                :src="require(`@/assets/images/calculator/calculadora.png`)"
                alt="Calculator"
              />
              <span>Calculadora de ahorro</span>
            </div>
          </div>
          <div class="col-md-6">
            <div class="text-right address">
              <i
                class="el-icon-location"
                style="color: #FF00B9; font-size: 26px"
              ></i>
              <span>{{ newClient.offers.offers[0].address }}</span>
            </div>
            <!-- Switch de 'ofertas potencia' -->
            <div class="text-right switch-offers" style="display:none">
              <label class="switch-offers-title">Ofertas potencia:</label>
              <div class="d-inline-flex align-self-center ml-2">
                <label class="switch-offers-label">
                  Actual
                </label>
                <div
                  ref="submitBtn"
                  class="switch pointer"
                  @click="switchSelectedOffersPower()"
                >
                  <span
                    class="slider"
                    :class="{ active: selectedOptimizedOfferPower === true }"
                  ></span>
                </div>
                <label class="switch-offers-label">
                  Optimizada
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-3"></div>

        <div class="row">
          <div class="col-lg-6">
            <label>OFERTAS PROPUESTAS-ELECTRICIDAD</label>
          </div>
        </div>
        <div style="background: #FFF">
          <div
            class="box"
            :class="{
              borderBottom:
                (offersOne && offersOne.length > 0) ||
                (offersOne &&
                  offersOne.length === 0 &&
                  (offersFlexi[0].consumoErratico === 1 ||
                    offersFlexi[0].consumoBajo === 1 ||
                    offersFlexi[0].consumoAlto === 1))
            }"
            v-if="offersFlexi && offersFlexi.length > 0"
          >
            <div
              class="checkbox"
              @click="
                sessionExpired;
                checkFlexi = !checkFlexi;
                checkFlexiOne = false;
                checkHoy = false;
                checkSimple = false;
              "
              :class="{ active: checkFlexi }"
              :style="{ 'background-color': checkFlexi ? '#FF00B9' : '#FFF' }"
            ></div>
            <div class="row" style="width: 100%;">
              <div class="col-lg-5 align-self-center">
                <div class="price-offer">
                  <label class="title">Tu tarifa FLEXI UNO</label>
                  <div class="variable">
                    <div>
                      <span><strong>Precio de energía,</strong></span>
                    </div>
                    <div>
                      <span>por kWh consumido:</span>
                    </div>
                    <div style="width: 100%; margin-top: 20px">
                      <span
                        ><strong
                          >{{
                            formatFixed(
                              "flexi",
                              "luzp1simp",
                              offersFlexi[0].luzp1simp,
                              4
                            )
                          }}
                          €/kWh</strong
                        >
                        (sin impuestos)</span
                      >
                    </div>
                    <div style="width: 100%">
                      <span
                        ><strong
                          >{{
                            formatFixed(
                              "flexi",
                              "luzp1cimp",
                              offersFlexi[0].luzp1cimp,
                              4
                            )
                          }}
                          €/kWh</strong
                        >
                        (con impuestos)</span
                      >
                    </div>
                    <span style="font-size: 28px"><strong>+</strong></span>
                    <div>
                      <span><strong>Cuota mensual prepago,</strong></span>
                    </div>
                    <div>
                      <span
                        >incluye la potencia, el alquiler del contador y los gastos de gestión y margen:</span
                      >
                    </div>
                    <div style="width: 100%; margin-top: 20px">
                      <span>
                        <strong
                          >{{
                            roundValue(
                              "flexi",
                              "cuota_luz_simp",
                              offersFlexi[0].cuota_luz_simp
                            )
                          }}
                          €/mes
                        </strong>
                        (sin impuestos)</span
                      >
                    </div>
                    <div style="width: 100%">
                      <span>
                        <strong
                          >{{
                            roundValue(
                              "flexi",
                              "cuota_luz_cimp",
                              offersFlexi[0].cuota_luz_cimp
                            )
                          }}
                          €/mes
                        </strong>
                        (con impuestos)</span
                      >
                    </div>
                    <label style="font-size: 18px; margin-top: 20px"
                      >Sujeto a permanencia</label
                    >
                  </div>
                </div>
              </div>
              <div class="col-lg-7 align-self-center">
                <div class="info-offer">
                  <label>
                    · Con FLEXI UNO pagarás una
                    <strong>media mensual de </strong>
                    <strong v-if="offersOne && offersOne.length === 0">
                      {{ calculateCuota(offersFlexi[0]) }} €/mes</strong
                    >
                    <strong v-if="offersOne && offersOne.length > 0">
                      {{
                        roundValue(
                          "one",
                          "cuota_luz_cimp",
                          offersOne[0].cuota_luz_cimp
                        )
                      }}
                      €/mes</strong
                    >
                    (con impuestos).
                  </label>
                  <label
                    >· Con una
                    <strong>
                      potencia contratada de
                      {{
                        formatFixed(
                          "flexi",
                          "p_contratada_electricidad",
                          offersFlexi[0].p_contratada_electricidad,
                          2
                        )
                      }}
                      kW.</strong
                    ></label
                  >
                  <label
                    >· Para una estimación de
                    <strong>
                      consumo anual de
                      {{
                        formatFixed(
                          "flexi",
                          "cac_electricidad",
                          offersFlexi[0].cac_electricidad,
                          2
                        )
                      }}
                      kWh </strong
                    >({{ Math.round(offersFlexi[0].cac_electricidad / 12) }}
                    kWh/mes) basada en el consumo real de los últimos 12 meses.
                  </label>
                  <label>
                    · La cuota mensual fija (pago por adelantado): se factura el
                    día 1 del mes.
                  </label>
                  <label>
                    · Al finalizar cada mes se calcula el consumo realizado y se
                    factura al precio del kWh.
                  </label>

                  <div class="row">
                    <div class="col-xs-1 col-md-1 col-lg-1">
                      <el-checkbox id="checkbox" class="checkbox" v-model="checkEnergiaVerde"></el-checkbox>
                    </div>
                    <div class="col-xs-11 col-md-11 col-lg-11">
                        <label>Quiero exclusivamente energía de origen renovable certificada por la CNMC<br></label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xs-1 col-md-1 col-lg-1"></div>
                    <div class="col-xs-11 col-md-11 col-lg-11">
                      <div class="row">
                        <div style="padding-left:15px !important; padding-right:15px !important">
                          <img src="https://wpalpha.mipodo.com/wp-content/uploads/2022/06/bombilla.png" width="15" height="15">
                        </div>
                        <div>
                          <label>(+0,00748 €/kWh*)</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-4 block">
                      <label>
                        <i class="el-icon-check"></i>
                        Con FLEXI UNO
                        <strong>pagas solo lo que consumes cada mes.</strong>
                      </label>
                    </div>
                    <div class="col-lg-4 block">
                      <label>
                        <i class="el-icon-check"></i>
                        El
                        <strong
                          >mismo precio fijo del kWh todas las horas del
                          día</strong
                        >
                        , para que consumas sin mirar el reloj.
                      </label>
                    </div>
                    <div class="col-lg-4 block">
                      <label>
                        <i class="el-icon-check"></i>
                        Tarifa recomendada si no quieres cambiar tus hábitos de consumo de electricidad en casa. 
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            :class="{
              separated:
                (offersOne && offersOne.length > 0) ||
                (offersOne &&
                  offersOne.length === 0 &&
                  offersFlexi &&
                  offersFlexi.length > 0 &&
                  (offersFlexi[0].consumoErratico === 1 ||
                    offersFlexi[0].consumoBajo === 1 ||
                    offersFlexi[0].consumoAlto === 1))
            }"
          ></div>
          <div
            class="box borderTop d-block"
            v-if="
              offersFlexi &&
                offersFlexi.length > 0 &&
                offersOne &&
                offersOne.length === 0
            "
          >
            <label v-if="offersFlexi[0].consumoAlto === 1">
              No se ofrece tarifa FIJO: el consumo mensual es muy elevado, es
              más conveniente una tarifa FLEXI 1.
            </label>
            <label
              v-if="
                offersFlexi[0].consumoBajo === 1 &&
                  offersFlexi[0].consumoAlto !== 1
              "
            >
              No se ofrece tarifa FIJO: el consumo mensual es muy bajo, es más
              conveniente una tarifa FLEXI 1.
            </label>
            <label
              v-if="
                offersFlexi[0].consumoErratico === 1 &&
                  offersFlexi[0].consumoBajo !== 1
              "
            >
              No se ofrece tarifa FIJO: el consumo mensual es irregular en esta
              dirección.
            </label>
          </div>
          <div class="box borderTop" v-if="offersOne && offersOne.length > 0">
            <div
              class="checkbox"
              @click="
                sessionExpired;
                checkFlexiOne = !checkFlexiOne;
                checkFlexi = false;
                checkHoy = false;
                checkSimple = false;
              "
              :class="{ active: checkFlexiOne }"
              :style="{
                'background-color': checkFlexiOne ? '#FF00B9' : '#FFF'
              }"
            ></div>
            <div class="row" style="width: 100%;">
              <div class="col-lg-5 align-self-center">
                <div class="price-offer">
                  <label class="title">Tu tarifa FIJO</label>
                  <div class="variable">
                    <div>
                      <span
                        ><strong>Una cuota mensual todo incluido</strong></span
                      >
                    </div>
                    <div style="width: 100%; margin-top: 20px">
                      <span>
                        <strong
                          >{{
                            roundValue(
                              "one",
                              "cuota_luz_simp",
                              offersOne[0].cuota_luz_simp
                            )
                          }}
                          €/mes
                        </strong>
                        (sin impuestos)</span
                      >
                    </div>
                    <div style="width: 100%; margin-bottom: 20px">
                      <span>
                        <strong
                          >{{
                            roundValue(
                              "one",
                              "cuota_luz_cimp",
                              offersOne[0].cuota_luz_cimp
                            )
                          }}
                          €/mes
                        </strong>
                        (con impuestos)</span
                      >
                    </div>
                    <div>
                      <span>
                        que incluye la potencia contratada, el alquiler del
                        contador, y todo el consumo mensual.
                      </span>
                    </div>
                    <div>
                      <span>
                        El precio de energía, para los ajustes de consumo al
                        final del contrato es de:
                      </span>
                    </div>
                    <div style="width: 100%; margin-top: 20px">
                      <span
                        ><strong
                          >{{
                            formatFixed(
                              "one",
                              "luzp1simp",
                              offersOne[0].luzp1simp,
                              4
                            )
                          }}
                          €/kWh</strong
                        >
                        (sin impuestos)</span
                      >
                    </div>
                    <div style="width: 100%">
                      <span
                        ><strong
                          >{{
                            formatFixed(
                              "one",
                              "luzp1cimp",
                              offersOne[0].luzp1cimp,
                              4
                            )
                          }}
                          €/kWh</strong
                        >
                        (con impuestos)</span
                      >
                    </div>
                    <label style="font-size: 18px; margin-top: 20px"
                      >Sujeto a permanencia</label
                    >
                  </div>
                </div>
              </div>
              <div class="col-lg-7 align-self-center">
                <div class="info-offer">
                  <label>
                    · Con FIJO pagarás
                    <strong>
                      {{
                        roundValue(
                          "one",
                          "cuota_luz_cimp",
                          offersOne[0].cuota_luz_cimp
                        )
                      }}
                      € mensuales
                    </strong>
                    (con impuestos).
                  </label>
                  <label
                    >· Con una
                    <strong>
                      potencia contratada de
                      {{
                        formatFixed(
                          "one",
                          "p_contratada_electricidad",
                          offersOne[0].p_contratada_electricidad,
                          2
                        )
                      }}
                      kW.</strong
                    ></label
                  >
                  <label
                    >· Para una estimación de
                    <strong>
                      consumo anual de
                      {{
                        formatFixed(
                          "one",
                          "cac_electricidad",
                          offersOne[0].cac_electricidad,
                          4
                        )
                      }}
                      kWh
                    </strong>
                    basada en el consumo real de los últimos 12 meses.
                  </label>
                  <label
                    >· La cuota mensual (pago por adelantado): se factura el día
                    1 del mes.
                  </label>
                  <label
                    >· Al finalizar el contrato de 12 meses se liquidará la
                    diferencia entre el consumo real y el estimado.
                  </label>

                  <div class="row">
                    <div class="col-xs-1 col-md-1 col-lg-1">
                      <el-checkbox id="checkbox" class="checkbox" v-model="checkEnergiaVerde"></el-checkbox>
                    </div>
                    <div class="col-xs-11 col-md-11 col-lg-11">
                        <label>Quiero exclusivamente energía de origen renovable certificada por la CNMC<br></label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xs-1 col-md-1 col-lg-1"></div>
                    <div class="col-xs-11 col-md-11 col-lg-11">
                      <div class="row">
                        <div style="padding-left:15px !important; padding-right:15px !important">
                          <img src="https://wpalpha.mipodo.com/wp-content/uploads/2022/06/bombilla.png" width="15" height="15">
                        </div>
                        <div>
                          <label>(+0,00748 €/kWh*)</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-4 block">
                      <label>
                        <i class="el-icon-check"></i>
                        Con FIJO
                        <strong>pagarás todos los meses lo mismo.</strong>
                        Calculamos tu consumo anual y lo dividimos en 12
                        mensualidades.
                      </label>
                    </div>
                    <div class="col-lg-4 block">
                      <label>
                        <i class="el-icon-check"></i>
                        Si al finalizar el contrato el
                        <strong>consumo real es mayor</strong>
                        al caculado:
                        <strong
                          >la direrencia se paga en una sola factura.</strong
                        >
                      </label>
                    </div>
                    <div class="col-lg-4 block">
                      <label>
                        <i class="el-icon-check"></i>
                        Si por el contrario, el
                        <strong>consumo real es menor</strong>
                        al caculado:
                        <strong
                          >Podo devolverá la diferencia mas un 3%, y se reducirá
                          la cuota para los 12 meses siguientes.</strong
                        >
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="box borderTop" v-if="offersHoy && offersHoy.length > 0">
            <div
              class="checkbox"
              @click="
                sessionExpired;
                checkHoy = !checkHoy;
                checkFlexi = false;
                checkFlexiOne = false;
                checkSimple = false;
              "
              :class="{ active: checkHoy }"
              :style="{
                'background-color': checkHoy ? '#FF00B9' : '#FFF'
              }"
            ></div>
            <div class="row" style="width: 100%;">
              <div class="col-lg-5 align-self-center">
                <div class="price-offer">
                  <label class="title">Tu tarifa FLEXI LUZ HOY</label>
                  <div class="variable">
                    <div>
                      <span
                        ><strong>Una cuota mensual todo incluido</strong></span
                      >
                    </div>
                    <div style="width: 100%; margin-top: 20px">
                      <span>
                        <strong
                          >{{
                            roundValue(
                              "hoy",
                              "cuota_luz_simp",
                              offersHoy[0].cuota_luz_simp
                            )
                          }}
                          €/mes
                        </strong>
                        (sin impuestos)</span
                      >
                    </div>
                    <div style="width: 100%; margin-bottom: 20px">
                      <span>
                        <strong
                          >{{
                            roundValue(
                              "hoy",
                              "cuota_luz_cimp",
                              offersHoy[0].cuota_luz_cimp
                            )
                          }}
                          €/mes
                        </strong>
                        (con impuestos)</span
                      >
                    </div>
                    <div>
                      <span>
                        que incluye la potencia contratada, el alquiler del
                        contador, y todo el consumo mensual.
                      </span>
                    </div>
                    <div>
                      <span>
                        El precio de energía, para los ajustes de consumo al
                        final del contrato es de:
                      </span>
                    </div>
                    <div style="width: 100%; margin-top: 20px">
                      <span
                        ><strong
                          >{{
                            formatFixed(
                              "hoy",
                              "luzp1simp",
                              offersHoy[0].luzp1simp,
                              4
                            )
                          }}
                          €/kWh</strong
                        >
                        (sin impuestos)</span
                      >
                    </div>
                    <div style="width: 100%">
                      <span
                        ><strong
                          >{{
                            formatFixed(
                              "one",
                              "luzp1cimp",
                              offersHoy[0].luzp1cimp,
                              4
                            )
                          }}
                          €/kWh</strong
                        >
                        (con impuestos)</span
                      >
                    </div>
                    <label style="font-size: 18px; margin-top: 20px"
                      >Sujeto a permanencia</label
                    >
                  </div>
                </div>
              </div>
              <div class="col-lg-7 align-self-center">
                <div class="info-offer">
                  <label>
                    · Con FLEXI LUZ HOY pagarás
                    <strong>
                      {{
                        roundValue(
                          "hoy",
                          "cuota_luz_cimp",
                          offersHoy[0].cuota_luz_cimp
                        )
                      }}
                      € mensuales
                    </strong>
                    (con impuestos).
                  </label>
                  <label
                    >· Con una
                    <strong>
                      potencia contratada de
                      {{
                        formatFixed(
                          "one",
                          "p_contratada_electricidad",
                          offersHoy[0].p_contratada_electricidad,
                          2
                        )
                      }}
                      kW.</strong
                    ></label
                  >
                  <label
                    >· Para una estimación de
                    <strong>
                      consumo anual de
                      {{
                        formatFixed(
                          "one",
                          "cac_electricidad",
                          offersHoy[0].cac_electricidad,
                          4
                        )
                      }}
                      kWh
                    </strong>
                    basada en el consumo real de los últimos 12 meses.
                  </label>
                  <label
                    >· La cuota mensual (pago por adelantado): se factura el día
                    1 del mes.
                  </label>
                  <label
                    >· Al finalizar el contrato de 12 meses se liquidará la
                    diferencia entre el consumo real y el estimado.
                  </label>

                  <div class="row">
                    <div class="col-xs-1 col-md-1 col-lg-1">
                      <el-checkbox id="checkbox" class="checkbox" v-model="checkEnergiaVerde"></el-checkbox>
                    </div>
                    <div class="col-xs-11 col-md-11 col-lg-11">
                        <label>Quiero exclusivamente energía de origen renovable certificada por la CNMC<br></label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xs-1 col-md-1 col-lg-1"></div>
                    <div class="col-xs-11 col-md-11 col-lg-11">
                      <div class="row">
                        <div style="padding-left:15px !important; padding-right:15px !important">
                          <img src="https://wpalpha.mipodo.com/wp-content/uploads/2022/06/bombilla.png" width="15" height="15">
                        </div>
                        <div>
                          <label>(+0,00748 €/kWh*)</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-4 block">
                      <label>
                        <i class="el-icon-check"></i>
                        Aprovecha la bajada de precio con nuestra tarifa<strong>FLEXI LUZ HOY.</strong>
                      </label>
                    </div>
                    <div class="col-lg-4 block">
                      <label>
                        <i class="el-icon-check"></i>
                        En todo momento, en todas las estaciones y sin sorpresas en tu factura mensual, 
                        <strong>HOY EMPIEZA TU AHORRO.</strong>
                      </label>
                    </div>
                    <div class="col-lg-4 block">
                      <label>
                        <i class="el-icon-check"></i>
                        <strong>Tu factura clara y sencilla.</strong>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="box borderTop" v-if="offersSimple && offersSimple.length > 0">
            <div
              class="checkbox"
              @click="
                sessionExpired;
                checkSimple = !checkSimple;
                checkFlexi = false;
                checkFlexiOne = false;
                checkHoy = false;
              "
              :class="{ active: checkSimple }"
              :style="{
                'background-color': checkSimple ? '#FF00B9' : '#FFF'
              }"
            ></div>
            <div class="row" style="width: 100%;">
              <div class="col-lg-5 align-self-center">
                <div class="price-offer">
                  <label class="title">Tu tarifa LUZ SIMPLE</label>
                  <div class="variable">
                    <div>
                      <span
                        ><strong>Una cuota mensual todo incluido</strong></span
                      >
                    </div>
                    <div style="width: 100%; margin-top: 20px">
                      <span>
                        <strong
                          >{{
                            roundValue(
                              "simple",
                              "cuota_luz_simp",
                              offersSimple[0].cuota_luz_simp
                            )
                          }}
                          €/mes
                        </strong>
                        (sin impuestos)</span
                      >
                    </div>
                    <div style="width: 100%; margin-bottom: 20px">
                      <span>
                        <strong
                          >{{
                            roundValue(
                              "simple",
                              "cuota_luz_cimp",
                              offersSimple[0].cuota_luz_cimp
                            )
                          }}
                          €/mes
                        </strong>
                        (con impuestos)</span
                      >
                    </div>
                    <div>
                      <span>
                        que incluye la potencia contratada, el alquiler del
                        contador, y todo el consumo mensual.
                      </span>
                    </div>
                    <label style="font-size: 18px; margin-top: 20px"
                      >Sujeto a permanencia</label
                    >
                  </div>
                </div>
              </div>
              <div class="col-lg-7 align-self-center">
                <div class="info-offer">
                  <label>
                    · Con LUZ SIMPLE pagarás
                    <strong>
                      {{
                        roundValue(
                          "simple",
                          "cuota_luz_cimp",
                          offersSimple[0].cuota_luz_cimp
                        )
                      }}
                      € mensuales
                    </strong>
                    (con impuestos).
                  </label>
                  <label
                    >· Con una
                    <strong>
                      potencia contratada de
                      {{
                        formatFixed(
                          "one",
                          "p_contratada_electricidad",
                          offersSimple[0].p_contratada_electricidad,
                          2
                        )
                      }}
                      kW.</strong
                    ></label
                  >
                  <label
                    >· Para una estimación de
                    <strong>
                      consumo anual de
                      {{
                        formatFixed(
                          "one",
                          "cac_electricidad",
                          offersSimple[0].cac_electricidad,
                          4
                        )
                      }}
                      kWh
                    </strong>
                    basada en el consumo real de los últimos 12 meses.
                  </label>
                  <label
                    >· La cuota mensual (pago por adelantado): se factura el día
                    1 del mes.
                  </label>
                  <label
                    >· Al finalizar el contrato de 12 meses se liquidará la
                    diferencia entre el consumo real y el estimado.
                  </label>

                  <div class="row">
                    <div class="col-xs-1 col-md-1 col-lg-1">
                      <el-checkbox id="checkbox" class="checkbox" v-model="checkEnergiaVerde"></el-checkbox>
                    </div>
                    <div class="col-xs-11 col-md-11 col-lg-11">
                        <label>Quiero exclusivamente energía de origen renovable certificada por la CNMC<br></label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xs-1 col-md-1 col-lg-1"></div>
                    <div class="col-xs-11 col-md-11 col-lg-11">
                      <div class="row">
                        <div style="padding-left:15px !important; padding-right:15px !important">
                          <img src="https://wpalpha.mipodo.com/wp-content/uploads/2022/06/bombilla.png" width="15" height="15">
                        </div>
                        <div>
                          <label>(+0,00748 €/kWh*)</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-4 block">
                      <label>
                        <i class="el-icon-check"></i>
                        <strong>SIMPLEMENTE, cuando el mercado baja estás seguro de pagar menos, 
                        y cuando sube te avisamos para ofrecerte otra tarifa.</strong>
                      </label>
                    </div>
                    <div class="col-lg-4 block">
                      <label>
                        <i class="el-icon-check"></i>
                        Disfruta de la libertad de un precio que baja, 
                        <strong>con la seguridad de ahorrar en tu factura.</strong>
                      </label>
                    </div>
                    <div class="col-lg-4 block">
                      <label>
                        <i class="el-icon-check"></i>
                        <strong> Tu factura clara y sencilla.</strong>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="block"
        style="margin-top: 50px"
        v-if="offersGas && offersGas.length > 0"
      >
        <label>OFERTA PROPUESTA-GAS</label>
        <div class="box borderBottom" v-if="offersFlexiGas && offersFlexiGas.length > 0">
          <span v-if="offersGas[0].peajegas === -1">
            No se ofrece FLEXI GAS, el consumo es tan elevado que recomendamos
            al cliente pasar a una tarifa 3.3 que Podo no ofrece.
          </span>
          <div
            class="checkbox"
            @click="
              sessionExpired;
              checkFlexiGAS = !checkFlexiGAS;
                checkGasHoy = false;
                checkGasSimple = false;
            "
            :class="{ active: checkFlexiGAS }"
            :style="{ 'background-color': checkFlexiGAS ? '#FF00B9' : '#FFF' }"
          ></div>
          <div
            class="row"
            style="width: 100%;"
          >
            <div class="col-lg-5 align-self-center">
              <div class="price-offer">
                <label class="title"
                  >Tu tarifa FLEXI GAS {{ offersGas[0].peajegas }}:</label
                >
                <div class="variable">
                  <div>
                    <span><strong>Precio de energía,</strong></span>
                  </div>
                  <div>
                    <span>por kWh consumido:</span>
                  </div>
                  <div style="width: 100%; margin-top: 20px">
                    <span
                      ><strong
                        >{{
                          formatFixed("flexigas", "gassimp", offersGas[0].gassimp, 4)
                        }}
                        €/kWh</strong
                      >
                      (sin impuestos)</span
                    >
                  </div>
                  <div style="width: 100%">
                    <span
                      ><strong
                        >{{
                          formatFixed("flexigas", "gascimp", offersGas[0].gascimp, 4)
                        }}
                        €/kWh</strong
                      >
                      (con impuestos)</span
                    >
                  </div>
                  <span style="font-size: 28px"><strong>+</strong></span>
                  <div>
                    <span><strong>Cuota mensual fija,</strong></span>
                  </div>
                  <div>
                    <span
                      >que incluye el termino de peaje fijo y el alquiler del
                      contador</span
                    >
                  </div>
                  <div style="width: 100%; margin-top: 20px">
                    <span>
                      <strong
                        >{{
                          roundValue(
                            "flexigas",
                            "cuota_gas_simp",
                            offersGas[0].cuota_gas_simp
                          )
                        }}
                        €/mes
                      </strong>
                      (sin impuestos)</span
                    >
                  </div>
                  <div style="width: 100%">
                    <span>
                      <strong
                        >{{
                          roundValue(
                            "flexigas",
                            "cuota_gas_cimp",
                            offersGas[0].cuota_gas_cimp
                          )
                        }}
                        €/mes
                      </strong>
                      (con impuestos)</span
                    >
                  </div>
                  <label style="font-size: 18px; margin-top: 20px"
                    >Sujeto a permanencia</label
                  >
                </div>
              </div>
            </div>
            <div class="col-lg-7 align-self-center">
              <div class="info-offer">
                <label>
                  · Con FLEXI GAS pagarás una
                  <strong>
                    media mensual de
                    {{
                      Math.round(
                        offersGas[0].cuota_gas_cimp +
                          (offersGas[0].cac_gas / 12) * offersGas[0].gascimp
                      )
                    }}
                    €/mes
                  </strong>
                  (con impuestos).
                </label>
                <label
                  >· Para una estimación de
                  <strong>
                    consumo anual de
                    {{ formatFixed("flexigas", "cac_gas", offersGas[0].cac_gas, 2) }}
                    kWh
                  </strong>
                  ({{ Math.round(offersGas[0].cac_gas / 12) }} kWh/mes) basada
                  en el consumo real de los últimos 12 meses.
                </label>
                <label
                  >· La cuota mensual (pago por adelantado): se factura el día 1
                  del mes.
                </label>
                <label
                  >· Al finalizar cada mes se calcula el consumo realizado y se
                  factura al precio del kWh.
                </label>
                <div class="row">
                  <div class="col-lg-4 block">
                    <label>
                      <i class="el-icon-check"></i>
                      Con FLEXI GAS
                      <strong>pagas solo lo que consumes cada mes.</strong>
                    </label>
                  </div>
                  <div class="col-lg-4 block">
                    <label>
                      <i class="el-icon-check"></i>
                      Un precio único las 24 horas del día, sin complicaciones. 
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box borderTop" v-if="offersGasHoy && offersGasHoy.length > 0">
          <span v-if="offersGas[1].peajegas === -1">
            No se ofrece FLEXI GAS, el consumo es tan elevado que recomendamos
            al cliente pasar a una tarifa 3.3 que Podo no ofrece.
          </span>
          <div
            class="checkbox"
            @click="
              sessionExpired;
              checkGasHoy = !checkGasHoy;
                checkFlexiGAS = false;
                checkGasSimple = false;
            "
            :class="{ active: checkGasHoy }"
            :style="{ 'background-color': checkGasHoy ? '#FF00B9' : '#FFF' }"
          ></div>
          <div
            class="row"
            style="width: 100%;"
          >
            <div class="col-lg-5 align-self-center">
              <div class="price-offer">
                <label class="title"
                  >FLEXI GAS HOY</label
                >
                <div class="variable">
                  <div>
                    <span><strong>Precio de energía,</strong></span>
                  </div>
                  <div>
                    <span>por kWh consumido:</span>
                  </div>
                  <div style="width: 100%; margin-top: 20px">
                    <span
                      ><strong
                        >{{
                          formatFixed("gashoy", "gassimp", offersGasHoy[0].gassimp, 4)
                        }}
                        €/kWh</strong
                      >
                      (sin impuestos)</span
                    >
                  </div>
                  <div style="width: 100%">
                    <span
                      ><strong
                        >{{
                          formatFixed("gashoy", "gascimp", offersGasHoy[0].gascimp, 4)
                        }}
                        €/kWh</strong
                      >
                      (con impuestos)</span
                    >
                  </div>
                  <span style="font-size: 28px"><strong>+</strong></span>
                  <div>
                    <span><strong>Cuota mensual fija,</strong></span>
                  </div>
                  <div>
                    <span
                      >que incluye el termino de peaje fijo y el alquiler del
                      contador</span
                    >
                  </div>
                  <div style="width: 100%; margin-top: 20px">
                    <span>
                      <strong
                        >{{
                          roundValue(
                            "gashoy",
                            "cuota_gas_simp",
                            offersGasHoy[0].cuota_gas_simp
                          )
                        }}
                        €/mes
                      </strong>
                      (sin impuestos)</span
                    >
                  </div>
                  <div style="width: 100%">
                    <span>
                      <strong
                        >{{
                          roundValue(
                            "gashoy",
                            "cuota_gas_cimp",
                            offersGasHoy[0].cuota_gas_cimp
                          )
                        }}
                        €/mes
                      </strong>
                      (con impuestos)</span
                    >
                  </div>
                  <label style="font-size: 18px; margin-top: 20px"
                    >Sujeto a permanencia</label
                  >
                </div>
              </div>
            </div>
            <div class="col-lg-7 align-self-center">
              <div class="info-offer">
                <label>
                  · Con FLEXI GAS HOY pagarás una
                  <strong>
                    media mensual de
                    {{
                      Math.round(
                        offersGasHoy[0].cuota_gas_cimp +
                          (offersGasHoy[0].cac_gas / 12) * offersGasHoy[0].gascimp
                      )
                    }}
                    €/mes
                  </strong>
                  (con impuestos).
                </label>
                <label
                  >· Para una estimación de
                  <strong>
                    consumo anual de
                    {{ formatFixed("gashoy", "cac_gas", offersGasHoy[0].cac_gas, 2) }}
                    kWh
                  </strong>
                  ({{ Math.round(offersGasHoy[0].cac_gas / 12) }} kWh/mes) basada
                  en el consumo real de los últimos 12 meses.
                </label>
                <label
                  >· La cuota mensual (pago por adelantado): se factura el día 1
                  del mes.
                </label>
                <label
                  >· Al finalizar cada mes se calcula el consumo realizado y se
                  factura al precio del kWh.
                </label>
                <div class="row">
                  <div class="col-lg-4 block">
                    <label>
                      <i class="el-icon-check"></i>
                      Cada instante el mejor precio del mercado.
                    </label>
                  </div>
                  <div class="col-lg-4 block">
                    <label>
                      <i class="el-icon-check"></i>
                      La tarifa FLEXI GAS HOY está pensada para que puedas ahorrar en todas las horas, desde <strong>HOY EMPIEZA TU AHORRO.</strong> 
                    </label>
                  </div>
                  <div class="col-lg-4 block">
                    <label>
                      <i class="el-icon-check"></i>
                      <strong>Tu factura clara y sencilla.</strong> 
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box borderTop" v-if="offersGasSimple && offersGasSimple.length > 0">
          <span v-if="offersGas[2].peajegas === -1">
            No se ofrece FLEXI GAS, el consumo es tan elevado que recomendamos
            al cliente pasar a una tarifa 3.3 que Podo no ofrece.
          </span>
          <div
            class="checkbox"
            @click="
              sessionExpired;
              checkGasSimple = !checkGasSimple;
                checkGasHoy = false;
                checkFlexiGAS = false;
            "
            :class="{ active: checkGasSimple }"
            :style="{ 'background-color': checkGasSimple ? '#FF00B9' : '#FFF' }"
          ></div>
          <div
            class="row"
            style="width: 100%;"
          >
            <div class="col-lg-5 align-self-center">
              <div class="price-offer">
                <label class="title"
                  >GAS SIMPLE</label
                >
                <div class="variable">
                  <div>
                    <span><strong>Precio de energía,</strong></span>
                  </div>
                  <div>
                    <span>por kWh consumido:</span>
                  </div>
                  <div style="width: 100%; margin-top: 20px">
                    <span
                      ><strong
                        >{{
                          formatFixed("gassimple", "gassimp", offersGasSimple[0].gassimp, 4)
                        }}
                        €/kWh</strong
                      >
                      (sin impuestos)</span
                    >
                  </div>
                  <div style="width: 100%">
                    <span
                      ><strong
                        >{{
                          formatFixed("gassimple", "gascimp", offersGasSimple[0].gascimp, 4)
                        }}
                        €/kWh</strong
                      >
                      (con impuestos)</span
                    >
                  </div>
                  <span style="font-size: 28px"><strong>+</strong></span>
                  <div>
                    <span><strong>Cuota mensual fija,</strong></span>
                  </div>
                  <div>
                    <span
                      >que incluye el termino de peaje fijo y el alquiler del
                      contador</span
                    >
                  </div>
                  <div style="width: 100%; margin-top: 20px">
                    <span>
                      <strong
                        >{{
                          roundValue(
                            "gassimple",
                            "cuota_gas_simp",
                            offersGasSimple[0].cuota_gas_simp
                          )
                        }}
                        €/mes
                      </strong>
                      (sin impuestos)</span
                    >
                  </div>
                  <div style="width: 100%">
                    <span>
                      <strong
                        >{{
                          roundValue(
                            "gassimple",
                            "cuota_gas_cimp",
                            offersGasSimple[0].cuota_gas_cimp
                          )
                        }}
                        €/mes
                      </strong>
                      (con impuestos)</span
                    >
                  </div>
                  <label style="font-size: 18px; margin-top: 20px"
                    >Sujeto a permanencia</label
                  >
                </div>
              </div>
            </div>
            <div class="col-lg-7 align-self-center">
              <div class="info-offer">
                <label>
                  · Con GAS SIMPLE pagarás una
                  <strong>
                    media mensual de
                    {{
                      Math.round(
                        offersGasSimple[0].cuota_gas_cimp +
                          (offersGasSimple[0].cac_gas / 12) * offersGasSimple[0].gascimp
                      )
                    }}
                    €/mes
                  </strong>
                  (con impuestos).
                </label>
                <label
                  >· Para una estimación de
                  <strong>
                    consumo anual de
                    {{ formatFixed("gassimple", "cac_gas", offersGasSimple[0].cac_gas, 2) }}
                    kWh
                  </strong>
                  ({{ Math.round(offersGasSimple[0].cac_gas / 12) }} kWh/mes) basada
                  en el consumo real de los últimos 12 meses.
                </label>
                <label
                  >· La cuota mensual (pago por adelantado): se factura el día 1
                  del mes.
                </label>
                <label
                  >· Al finalizar cada mes se calcula el consumo realizado y se
                  factura al precio del kWh.
                </label>
                <div class="row">
                  <div class="col-lg-4 block">
                    <label>
                      <i class="el-icon-check"></i>
                      <strong>SIMPLEMENTE,</strong> cuando el mercado baja estás seguro de pagar menos, y cuando sube te avisamos para ofrecerte otra tarifa.
                    </label>
                  </div>
                  <div class="col-lg-4 block">
                    <label>
                      <i class="el-icon-check"></i>
                      Disfruta de la libertad de un precio que baja, <strong>con la seguridad de ahorrar en tu factura.</strong> 
                    </label>
                  </div>
                  <div class="col-lg-4 block">
                    <label>
                      <i class="el-icon-check"></i>
                      <strong>Tu factura clara y sencilla.</strong> 
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-lg-4">
        <el-button class="btn btn_secondary return" @click="cancelButton()">
          Volver atrás
        </el-button>
      </div>
      <div class="col-lg-8 text-right">
        <div class="buttons">
          <el-button id="order2" class="btn btn_gradient" @click="sendOffers()">
            Continuar
          </el-button>
          <el-button
            id="order1"
            class="btn btn_secondary"
            @click="
              showModal = true;
              titleModal = '¿Estas seguro que quieres cancelar?';
            "
          >
            Cancelar
          </el-button>
        </div>
      </div>
    </div>
    <Modal
      v-if="showModal"
      :size="'small'"
      :theme="'pink'"
      @close="
        showModal = false;
        titleModal = '';
        contentModal = '';
      "
    >
      <template v-slot:content>
        <div v-if="!titleModal" class="text-center" id="text">
          <label v-if="contentModal" v-html="contentModal"></label>
          <button
            class="btn"
            style="margin: 20px 0px 0px 0px"
            @click="acceptButton()"
          >
            Aceptar
          </button>
        </div>
        <div v-if="titleModal" class="text-center" id="text">
          <label v-html="titleModal"></label>
          <div class="row">
            <div
              class="col-md-6 text-center"
              v-if="titleModal !== '¿Estas seguro que quieres cancelar?'"
            >
              <button
                class="btn"
                style="width: 100%; margin: 20px 0px 0px 0px"
                @click="printOffers()"
              >
                Imprimir
              </button>
            </div>
            <div
              class="col-md-6 text-center"
              v-if="titleModal !== '¿Estas seguro que quieres cancelar?'"
            >
              <button
                class="btn"
                style="width: 100%; margin: 20px 0px 0px 0px"
                @click="
                  clearInfo();
                  cancelButton();
                "
              >
                Aceptar
              </button>
            </div>
            <div
              class="col-12 text-center"
              v-if="titleModal === '¿Estas seguro que quieres cancelar?'"
            >
              <button
                class="btn"
                style="margin: 30px 0px 0px 0px"
                @click="
                  clearInfo();
                  cancelButton();
                "
              >
                Aceptar
              </button>
            </div>
          </div>
        </div>
      </template>
    </Modal>

    <!-- Modal de mostrar mensaje -->
    <Modal
      v-if="showModalMsg"
      :size="'small'"
      :theme="'pink'"
      @close="showModalMsg = false"
    >
      <template v-slot:content>
        <div class="text-center" id="text">
          <label>{{ modalMsgContent }}</label>
          <button
            class="btn"
            style="margin: 40px 0px"
            @click="showModalMsg = false"
            v-on:click="prueba()"
          >
            Aceptar
          </button>
        </div>
      </template>
    </Modal>

    <!-- Modal de mostrar ofertas -->
    <Modal
      v-if="showModalOffer"
      :size="'medium'"
      :theme="'pink'"
      :scrollable="false"
      @close="showModalOffer = false"
    >
      <template v-slot:content>
        <div class="text-center" id="text">
          <label
            >¡Felicidades, tienes un buen precio!, pero eso no lo es
            todo:</label
          >
          <ul>
            <li>
              <label>Podo ofrece Luz 100% verde</label>
            </li>
            <li>
              <label>Excelente atención al cliente 24/7</label>
            </li>
            <li>
              <label>25€ de dto. por cada amigo que traigas.</label>
            </li>
          </ul>
          <br />
          <label style="display: block; font-weight: bold"
            >¡Vente a Podo!</label
          >
        </div>
      </template>
    </Modal>

    <!-- Modal de 'calculadora ahorro luz y gas' -->
    <CalculatorSpecialModal
      v-if="showCalculatorModal"
      :size="'large'"
      :theme="'white'"
      :customHeight="true"
      :customWidth="true"
      :title="'COMPARAMOS TU FACTURA DE LUZ'"
      @close="closeCalculatorModal()"
    >
      <template v-slot:content>
        <div class="calculator-modal-content">
          <div class="row">
            <div class="col-12">
              <label class="calc-modal-text"
                >Aqui podrás realizar una comparativa de la factura actual del
                cliente con la oferta que presenta Podo.</label
              >
            </div>
          </div>

          <div class="row">
            <div class="col-xl-8 col-sm-12">
              <div class="calc-form">
                <el-form
                  :model="calcModalCompareForm"
                  name="calcModalCompareForm"
                  :rules="calcModalCompareRules"
                  status-icon
                  ref="calcModalCompareForm"
                >
                  <div class="row">
                    <div class="col-12">
                      <label class="calc-modal-text-bold"
                        >Cumplimenta los siguientes campos (SIN
                        IMPUESTOS):</label
                      >
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-6 col-md-12">
                      <el-form-item prop="period">
                        <el-input
                          v-model="calcModalCompareForm.period"
                          autocomplete="off"
                          @focus="sessionExpired"
                          placeholder="Periodo facturación*"
                        >
                          <template slot="append">días</template>
                        </el-input>
                      </el-form-item>
                    </div>

                    <div class="col-lg-6 col-md-12">
                      <el-form-item prop="power">
                        <el-input
                          v-model="calcModalCompareForm.power"
                          autocomplete="off"
                          @focus="sessionExpired"
                          placeholder="Potencia contratada*"
                        >
                          <template slot="append">kW</template>
                        </el-input>
                      </el-form-item>
                    </div>
                  </div>

                  <!-- Precio de potencia actual -->
                  <div class="row">
                    <div class="col-lg-12 col-md-12">
                      <el-form-item prop="powerPrice">
                        <el-input
                          v-model="calcModalCompareForm.powerPrice"
                          autocomplete="off"
                          @focus="sessionExpired"
                          placeholder="Precio potencia actual*"
                        >
                          <template slot="append">€/kW/día</template>
                        </el-input>
                      </el-form-item>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-12 col-md-12">
                      <el-form-item
                        class="d-inline-flex align-self-center"
                        prop="timeDiscrimination"
                      >
                        <label class="calc-modal-text-bold"
                          >Discriminación horaria:</label
                        >
                        <div class="calc-modal-slider-container">
                          <label
                            class="pointer"
                            @click="
                              calcModalCompareForm.timeDiscrimination = false
                            "
                          >
                            NO
                          </label>
                          <div
                            class="switch pointer"
                            @click="timeDiscriminationChanged()"
                          >
                            <span
                              class="slider"
                              :class="{
                                active:
                                  calcModalCompareForm.timeDiscrimination ===
                                  true
                              }"
                            ></span>
                          </div>

                          <label
                            class="pointer"
                            @click="
                              calcModalCompareForm.timeDiscrimination = true
                            "
                          >
                            SI
                          </label>
                        </div>
                      </el-form-item>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-6 col-md-12">
                      <label class="calc-modal-text-bold"
                        >Precio energía actual
                      </label>
                      <el-form-item prop="currentPowerPricePeriodOne">
                        <el-input
                          v-model="
                            calcModalCompareForm.currentPowerPricePeriodOne
                          "
                          autocomplete="off"
                          @focus="sessionExpired"
                          placeholder="Periodo 1*"
                        >
                          <template slot="append">€/kWh</template></el-input
                        >
                      </el-form-item>

                      <el-form-item
                        v-if="calcModalCompareForm.timeDiscrimination"
                        prop="currentPowerPricePeriodTwo"
                      >
                        <el-input
                          v-model="
                            calcModalCompareForm.currentPowerPricePeriodTwo
                          "
                          autocomplete="off"
                          @focus="sessionExpired"
                          placeholder="Periodo 2*"
                        >
                          <template slot="append">€/kWh</template>
                        </el-input>
                      </el-form-item>
                    </div>

                    <div class="col-lg-6 col-md-12">
                      <label class="calc-modal-text-bold">Consumo </label>
                      <el-form-item prop="consumptionPeriodOne">
                        <el-input
                          v-model="calcModalCompareForm.consumptionPeriodOne"
                          autocomplete="off"
                          @focus="sessionExpired"
                          placeholder="Periodo 1*"
                          ><template slot="append">kWh</template>
                        </el-input>
                      </el-form-item>
                      <el-form-item
                        v-if="calcModalCompareForm.timeDiscrimination"
                        prop="consumptionPeriodTwo"
                      >
                        <el-input
                          v-model="calcModalCompareForm.consumptionPeriodTwo"
                          autocomplete="off"
                          @focus="sessionExpired"
                          placeholder="Periodo 2*"
                          ><template slot="append">kWh</template>
                        </el-input>
                      </el-form-item>
                    </div>
                  </div>

                  <!-- Otros servicios -->
                  <div class="row mt-2">
                    <div class="col-lg-12 col-md-12">
                      <el-form-item prop="otherServicesPrice">
                        <el-input
                          v-model="calcModalCompareForm.otherServicesPrice"
                          autocomplete="off"
                          @focus="sessionExpired"
                          placeholder="Otros servicios"
                          ><template slot="append">€/mes</template>
                        </el-input>
                      </el-form-item>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 text-right">
                      <el-button
                        id="submitCalcCompareForm"
                        class="btn btn_gradient"
                        @click="calculateSavings()"
                      >
                        Calcular ahorro
                      </el-button>
                    </div>
                  </div>
                </el-form>
              </div>
            </div>
            <!-- Columna de la derecha -->
            <div class="col-xl-4 col-sm-12 d-flex align-items-center">
              <div class="calc-modal-info-container">
                <div class="calc-modal-info-title mb-4">Con Podo ahorrarás</div>
                <div class="calc-modal-info-price">
                  {{ savingsTotal.electricityMonth }} €/mes (con impuestos)
                </div>
                <div class="calc-modal-info-price mb-2">
                  {{ savingsTotal.electricityYear }} €/año (con impuestos)
                </div>
                <div class="calc-modal-info-bold">
                  Potencia optimizada a 3.35 kW
                </div>
                <div class="calc-modal-info-normal mt-4">
                  Comparativa sin tener en cuenta el coste de servicios
                  adicionales con Podo.
                </div>
              </div>
            </div>
          </div>

          <!-- COMPARADOR DE GAS -->
          <div class="row">
            <div class="col-12">
              <hr />
              <label class="calc-modal-title"
                >COMPARAMOS TU FACTURA DE GAS</label
              >
              <i
                :class="
                  gasFormCollapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'
                "
                class="custom-icon"
                v-b-toggle="'gasForm-collapse'"
                @click="collapseGasForm()"
              ></i>
              <hr />
            </div>
          </div>

          <b-collapse id="gasForm-collapse">
            <div class="row">
              <div class="col-xl-8 col-sm-12">
                <div class="calc-form">
                  <el-form
                    :model="calcModalCompareGasForm"
                    name="calcModalCompareGasForm"
                    :rules="calcModalCompareGasRules"
                    status-icon
                    ref="calcModalCompareGasForm"
                  >
                    <div class="row">
                      <div class="col-lg-12 col-md-12">
                        <el-form-item prop="period">
                          <el-input
                            v-model="calcModalCompareGasForm.period"
                            autocomplete="off"
                            @focus="sessionExpired"
                            placeholder="Periodo de facturación*"
                            ><template slot="append">días</template>
                          </el-input>
                        </el-form-item>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-12 col-md-12">
                        <el-form-item prop="toll">
                          <el-input
                            v-model="calcModalCompareGasForm.toll"
                            autocomplete="off"
                            @focus="sessionExpired"
                            placeholder="Peaje de término fijo de gas (sin impuestos)*"
                            ><template slot="append">€/día</template>
                          </el-input>
                        </el-form-item>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-12 col-md-12">
                        <el-form-item prop="energyPrice">
                          <el-input
                            v-model="calcModalCompareGasForm.energyPrice"
                            autocomplete="off"
                            @focus="sessionExpired"
                            placeholder="Precio de energía actual de gas (sin impuestos)*"
                            ><template slot="append">€/kWh</template>
                          </el-input>
                        </el-form-item>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-12 col-md-12">
                        <el-form-item prop="consumption">
                          <el-input
                            v-model="calcModalCompareGasForm.consumption"
                            autocomplete="off"
                            @focus="sessionExpired"
                            placeholder="Consumo*"
                            ><template slot="append">kWh</template>
                          </el-input>
                        </el-form-item>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-12 col-md-12">
                        <el-form-item prop="otherServices">
                          <el-input
                            v-model="calcModalCompareGasForm.otherServices"
                            autocomplete="off"
                            @focus="sessionExpired"
                            placeholder="Otros servicios (sin impuestos)"
                            ><template slot="append">€/mes</template>
                          </el-input>
                        </el-form-item>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 text-right">
                        <el-button
                          id="submitCalcCompareForm"
                          class="btn btn_gradient"
                          @click="calculateGasSavings()"
                        >
                          Calcular ahorro
                        </el-button>
                      </div>
                    </div>
                  </el-form>
                </div>
              </div>
              <div class="col-xl-4 col-sm-12 d-flex align-items-center">
                <div class="calc-modal-info-container">
                  <div class="calc-modal-info-title mb-4">
                    Con Podo ahorrarás
                  </div>
                  <div class="calc-modal-info-price">
                    {{ savingsTotal.gasMonth }} €/mes (con impuestos)
                  </div>
                  <div class="calc-modal-info-price">
                    {{ savingsTotal.gasYear }} €/año (con impuestos)
                  </div>
                  <div class="calc-modal-info-normal mt-4">
                    Comparativa sin tener en cuenta el coste de servicios
                    adicionales con Podo.
                  </div>
                </div>
              </div>
            </div>
          </b-collapse>

          <div class="row mt-4">
            <div class="col-12">
              <label class="calc-modal-text mt-2"
                >Los campos marcados con (*) son obligatorios</label
              >
            </div>
          </div>
          <hr />
        </div>
      </template>
    </CalculatorSpecialModal>
  </div>
</template>

<script>
// Components
import Modal from "@/components/Modal";
import CalculatorSpecialModal from "@/components/CalculatorSpecialModal";
import ContractService from "@/services/contract.service";
import OfferService from "@/services/offer.service";
import AuthService from "@/services/auth.service";

import { mapState } from "vuex";
import EventBus from "@/plugins/EventBus";

import Lead from "../../model/Lead";
import { saveAs } from "file-saver";
import { Loading } from "element-ui";

import moment from "moment";
import Savings from "../../model/Savings/Savings";
import SavingsElectricity from "../../model/Savings/SavingsElectricity";
import SavingsGas from "../../model/Savings/SavingsGas";

export default {
  name: "Offer",
  components: { Modal, CalculatorSpecialModal },
  computed: {
    ...mapState({
      userLogged: "user"
    })
  },
  data() {
    const numberRule = (rule, value, callback) => {
      if (value !== null) {
        value = this.formatCalculatorFormValues(value);
      }

      if (value === "" || value === null) {
        callback(new Error("Por favor rellena este campo"));
      } else if (!Number(value)) {
        callback(new Error("El campo debería ser un número (mayor que cero)"));
      } else {
        callback();
      }
    };

    const notRequiredNumberRule = (rule, value, callback) => {
      if (value !== null) {
        value = this.formatCalculatorFormValues(value);
      }

      if (value !== "" && value !== null && !Number(value)) {
        callback(new Error("El campo debería ser un número (mayor que cero)"));
      } else {
        callback();
      }
    };

    return {
      title: "NUEVO CLIENTE",
      checkFlexi: false,
      checkFlexiOne: false,
      checkHoy: false,
      checkSimple: false,
      checkFlexiGAS: false,
      checkGasHoy: false,
      checkGasSimple: false,
      showModal: false,
      titleModal: "",
      contentModal: "",
      leadForm: {},
      offers: [],
      offersFlexi: [],
      offersOne: [],
      offersSimple: [],
      offersHoy: [],
      offersGas: [],
      offersFlexiGas: [],
      offersGasHoy: [],
      offersGasSimple: [],
      newClient: [],
      electricityCups: null,
      gasCups: null,
      checkEnergiaVerde: false,
      today: this.formatDate(new Date()),
      contractResponse: {
        base64: null,
        publicOperation: null
      },
      selectedOptimizedOfferPower: true,
      addressInfo: null,
      // Modal calculadora
      showModalMsg: false,
      modalMsgContent: "",
      showModalOffer: false,
      savingsTotal: {
        electricityMonth: "0",
        electricityYear: "0",
        gasMonth: "0",
        gasYear: "0"
      },
      showCalculatorModal: false,
      calcModalCompareForm: {
        period: null,
        power: null,
        powerPrice: null,
        timeDiscrimination: true,
        currentPowerPricePeriodOne: null,
        currentPowerPricePeriodTwo: null,
        consumptionPeriodOne: null,
        consumptionPeriodTwo: null,
        otherServicesPrice: null
      },
      calcModalCompareRules: {
        period: {
          validator: numberRule,
          trigger: "blur"
        },
        power: {
          validator: numberRule,
          trigger: "blur"
        },
        powerPrice: {
          validator: numberRule,
          trigger: "blur"
        },
        currentPowerPricePeriodOne: {
          validator: numberRule,
          trigger: "blur"
        },
        currentPowerPricePeriodTwo: {
          validator: numberRule,
          trigger: "blur"
        },
        consumptionPeriodOne: {
          validator: numberRule,
          trigger: "blur"
        },
        consumptionPeriodTwo: {
          validator: numberRule,
          trigger: "blur"
        },
        otherServicesPrice: {
          required: false,
          validator: notRequiredNumberRule,
          trigger: "blur"
        }
      },
      gasFormCollapsed: true,
      calcModalCompareGasForm: {
        period: null,
        //rate: null,
        toll: null,
        energyPrice: null,
        consumption: null,
        otherServices: null
      },
      calcModalCompareGasRules: {
        period: {
          validator: numberRule,
          trigger: "blur"
        },
        /*
        rate: {
          validator: numberRule,
          trigger: "blur"
        },*/
        toll: {
          validator: numberRule,
          trigger: "blur"
        },
        energyPrice: {
          validator: numberRule,
          trigger: "blur"
        },
        consumption: {
          validator: numberRule,
          trigger: "blur"
        },
        otherServices: {
          required: false,
          validator: notRequiredNumberRule,
          trigger: "blur"
        }
      }
    };
  },
  mounted() {

    console.log("Método para evento click");
    this.switchSelectedOffersPower();
    console.log("Después del método para evento click");
    this.sessionExpired();
    document.querySelector("#app").scrollTop = 0;
    if (localStorage.getItem("newClient"))
      this.completeData(JSON.parse(localStorage.getItem("newClient")));
  },
  methods: {
    /* Muestra el modal de la calculadora de ahorro */
    openCalculatorModal() {
      this.gasFormCollapsed = true;
      this.showCalculatorModal = true;
    },

    /* Cierra el modal de la calculadora de ahorro */
    closeCalculatorModal() {
      this.showCalculatorModal = false;
    },

    /* Modal calculadora de ahorro: invierte el flag de activado/desactivado */
    timeDiscriminationChanged() {
      if (this.calcModalCompareForm.timeDiscrimination === true) {
        this.calcModalCompareForm.timeDiscrimination = false;
      } else {
        this.calcModalCompareForm.timeDiscrimination = true;
      }
    },

    /* Calcula el ahorro de la oferta de electricidad */
    calculateSavings() {
      if (this.offersFlexi === null || this.offersFlexi.length == 0) {
        this.modalMsgContent =
          "No hay una oferta de electricidad sobre la que calcular el ahorro";
        this.showModalMsg = true;
        return;
      }

      this.$refs["calcModalCompareForm"].validate(valid => {
        if (valid) {
          const ElectricityData = new SavingsElectricity();
          ElectricityData.producto = "Flexi Uno";
          ElectricityData.p_actual = Number(
            this.formatCalculatorFormValues(
              this.calcModalCompareForm.powerPrice
            )
          );
          ElectricityData.p_contratada = Number(
            this.formatCalculatorFormValues(this.calcModalCompareForm.power)
          );
          ElectricityData.p_potencia_podo =
            ((this.offersFlexi[0].cuota_luz_simp - 0.85) * 12) /
            365 /
            ElectricityData.p_contratada; // 0.126742108;
          ElectricityData.dias = Number(
            this.formatCalculatorFormValues(this.calcModalCompareForm.period)
          );

          if (this.calcModalCompareForm.timeDiscrimination) {
            ElectricityData.energia1 = Number(
              this.formatCalculatorFormValues(
                this.calcModalCompareForm.consumptionPeriodOne
              )
            );
            ElectricityData.energia2 = Number(
              this.formatCalculatorFormValues(
                this.calcModalCompareForm.consumptionPeriodTwo
              )
            );

            ElectricityData.precio_energia_actual = 0;
            ElectricityData.precio_energia_actual_1 = Number(
              this.formatCalculatorFormValues(
                this.calcModalCompareForm.currentPowerPricePeriodOne
              )
            );
            ElectricityData.precio_energia_actual_2 = Number(
              this.formatCalculatorFormValues(
                this.calcModalCompareForm.currentPowerPricePeriodTwo
              )
            );
          } else {
            ElectricityData.precio_energia_actual = Number(
              this.formatCalculatorFormValues(
                this.calcModalCompareForm.currentPowerPricePeriodOne
              )
            );
            ElectricityData.precio_energia_actual_1 = 0;
            ElectricityData.precio_energia_actual_2 = 0;

            ElectricityData.energia1 = Number(
              this.formatCalculatorFormValues(
                this.calcModalCompareForm.consumptionPeriodOne
              )
            );
            ElectricityData.energia2 = 0;
          }

          ElectricityData.precio_flexi1 = Number(this.offersFlexi[0].luzp1simp);
          ElectricityData.precio_flexi2_1 = 0;
          ElectricityData.precio_flexi2_2 = 0;

          const SavingsData = new Savings();
          SavingsData.branch = "Electricidad";
          SavingsData.islas_peninsula = "Peninsula";
          SavingsData.electricity = ElectricityData;
          SavingsData.gas = new SavingsGas(0, 0, 0, 0, 0, 0);
          SavingsData.otherServices = Number(
            this.formatCalculatorFormValues(
              this.calcModalCompareForm.otherServicesPrice
            )
          );

          //console.log(SavingsData);
          const loadingInstance = Loading.service({ fullscreen: true });
          OfferService.getSavings(SavingsData)
            .then(response => {
              loadingInstance.close();
              this.savingsTotal.electricityMonth = response.data.data.finalSaving
                .toFixed(2)
                .replace(".", ",");
              this.savingsTotal.electricityYear =
                response.data.data.finalSaving * 12;
              this.savingsTotal.electricityYear = this.savingsTotal.electricityYear
                .toFixed(2)
                .replace(".", ",");
              if (response.data.data.finalSaving <= 0) {
                this.showModalOffer = true;
              }
            })
            .catch((/*error*/) => {
              loadingInstance.close();
              this.modalMsgContent =
                "Con los datos introducidos no se ha podido calcular el ahorro";
              this.showModalMsg = true;
              //console.log(error);
            });
        } else {
          return false;
        }
      });
    },

    /* Calcula el ahorro de la oferta de gas */
    calculateGasSavings() {
      if (this.offersGas === null || this.offersGas.length == 0) {
        this.modalMsgContent =
          "No hay una oferta de gas sobre la que calcular el ahorro";
        this.showModalMsg = true;
        return;
      }

      this.$refs["calcModalCompareGasForm"].validate(valid => {
        if (valid) {
          const GasData = new SavingsGas();
          GasData.p_fijo_actual = Number(
            this.formatCalculatorFormValues(this.calcModalCompareGasForm.toll)
          );
          GasData.p_gas = Number(
            this.formatCalculatorFormValues(
              this.calcModalCompareGasForm.energyPrice
            )
          );
          GasData.dias = Number(
            this.formatCalculatorFormValues(this.calcModalCompareGasForm.period)
          );
          GasData.energia = Number(
            this.formatCalculatorFormValues(
              this.calcModalCompareGasForm.consumption
            )
          );

          GasData.p_gas_podo = Number(this.offersGas[0].gassimp); // 0.0495 €
          GasData.p_fijo_podo =
            ((this.offersGas[0].cuota_gas_simp - 0.85) * 12) / 365;

          const SavingsData = new Savings();
          SavingsData.branch = "Gas";
          SavingsData.islas_peninsula = "Peninsula";
          SavingsData.electricity = new SavingsElectricity(
            "Flexi Uno",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          );
          SavingsData.gas = GasData;
          SavingsData.otherServices = Number(
            this.formatCalculatorFormValues(
              this.calcModalCompareGasForm.otherServices
            )
          );

          //console.log(SavingsData);
          const loadingInstance = Loading.service({ fullscreen: true });
          OfferService.getSavings(SavingsData)
            .then(response => {
              loadingInstance.close();
              this.savingsTotal.gasMonth = response.data.data.finalSaving
                .toFixed(2)
                .replace(".", ",");
              this.savingsTotal.gasYear = response.data.data.finalSaving * 12;
              this.savingsTotal.gasYear = this.savingsTotal.gasYear
                .toFixed(2)
                .replace(".", ",");
              if (response.data.data.finalSaving <= 0) {
                this.showModalOffer = true;
              }
            })
            .catch((/*error*/) => {
              loadingInstance.close();
              this.modalMsgContent =
                "Con los datos introducidos no se ha podido calcular el ahorro";
              this.showModalMsg = true;
              //console.log(error);
            });
        } else {
          return false;
        }
      });
    },

    /* Colapsa la sección del comparador de Gas (en el modal de la calcuadora de ahorro) */
    collapseGasForm() {
      this.gasFormCollapsed = !this.gasFormCollapsed;
    },

    /* Formatea los valores de los inputs de los formularios (del modal de la calculadora de ahorro) */
    formatCalculatorFormValues(value) {
      // TODO: refinarlo en temas como este --> 34.1.2.3,45 --devuelve--> 34123.45
      // Nota: de momento según Ángel dejarlo así
      if (value !== null) {
        const DotCounter = value.split(".").length - 1;
        const CommaCounter = value.split(",").length - 1;
        if (DotCounter > 0 && CommaCounter > 0) {
          value = value.replace(/\./g, "");
        }
        const Result = value.replace(/,/g, ".");
        return Result;
      }

      return value;
    },

    /* Procesa un cambio en el switch de potencia de las ofertas */
    switchSelectedOffersPower() {
      if (localStorage.getItem("newClient")) {
        this.selectedOptimizedOfferPower = !this.selectedOptimizedOfferPower;

        const ClientData = JSON.parse(localStorage.getItem("newClient"));
        const LeadData = new Lead(
          ClientData.lead.firstName,
          ClientData.lead.lastName,
          ClientData.lead.email,
          ClientData.lead.phone,
          null,
          ClientData.lead.city,
          ClientData.lead.province,
          ClientData.lead.address,
          ClientData.lead.number,
          ClientData.lead.portal,
          ClientData.lead.stair,
          ClientData.lead.floor,
          ClientData.lead.door,
          null // Este campo sería 'CUPS' (pero no existe en localStorage, tras hablar con Víctor en principio se deja a null)
        );

        // Solicitamos los nuevos datos...
        const loadingInstance = Loading.service({ fullscreen: true });
        OfferService.getOffers(
          LeadData,
          ClientData.cups,
          ClientData.cupsGas,
          this.selectedOptimizedOfferPower
        )
          .then(response => {
            // Actualizamos las ofertas...
            this.offersGas = response.data.data.offersGas;
            const ofertasLuz = response.data.data.offers !== null
                ? response.data.data.offers
                : [];
            this.offers =
              response.data.data.offers !== null
                ? response.data.data.offers
                : [];

            // this.offers.array.forEach(element => {
            //   if(element.producto == "FLEXI UNO"){
            //     this.offersFlexi = element;
            //   }else if(element.producto == "FIJO"){
            //     this.offersOne = element; 
            //   }else if(element.producto == "FLEXI LUZ HOY"){
            //     this.offersHoy = element; 
            //   }else if(element.producto == "LUZ SIMPLE"){
            //     this.offersSimple = element; 
            //   }
            // });

              let ofertaFlexiUno;
              let ofertaFijo;
              let ofertaHoy;
              let ofertaSimple;

            if (ofertasLuz) {
              ofertaFlexiUno = ofertasLuz.filter( offer => offer.producto === "FLEXI UNO");
              ofertaFijo = ofertasLuz.filter( offer => offer.producto === "FIJO");
              ofertaHoy = ofertasLuz.filter(offer => offer.producto === "FLEXI LUZ HOY");
              ofertaSimple = ofertasLuz.filter(offer =>offer.producto === "LUZ SIMPLE");
            }

            this.offersFlexi =  ofertaFlexiUno;
            this.offersOne = ofertaFijo;
            this.offersHoy = ofertaHoy;
            this.offersSimple = ofertaSimple;


            this.offersFlexi =  ofertaFlexiUno;

            console.log("IMPRIMO FIJO");
            console.log("Antes de asignarlo");
            console.log(ofertaFijo)
            this.offersOne = ofertaFijo;
            console.log("Después de asignarlo");
            console.log(this.offersOne);


            this.offersHoy = ofertaHoy;
            this.offersSimple = ofertaSimple;
            
            console.log("Después de asignar los otros 2");
            console.log(this.offersOne);

            if(this.offersGas){
              this.offersFlexiGas = this.offersGas.filter(
                offer =>
                  offer.producto === "FLEXI GAS" 
                  // ||
                  // offer.producto === "FLEXI GAS + FLEXI UNO"
              );
              this.offersGasHoy = this.offersGas.filter(
                offer =>
                  offer.producto === "FLEXI GAS HOY" 
              );
              this.offersGasSimple = this.offersGas.filter(
                offer =>
                  offer.producto === "GAS SIMPLE" 
              );
            }

            loadingInstance.close();
          })
          .catch((/*error*/) => {
            //console.log(error);
            loadingInstance.close();
            this.selectedOptimizedOfferPower = !this
              .selectedOptimizedOfferPower;
            this.modalMsgContent =
              "No se pueden obtener ofertas para la potencia actual";
            this.showModalMsg = false;
          });
      } else {
        this.modalMsgContent =
          "No se pueden obtener ofertas para la potencia actual";
        this.showModalMsg = true;
      }
    },

    sessionExpired() {
      AuthService.sessionExpired();
    },
    completeData(newClient) {
      this.newClient = newClient;
      this.electricityCups = newClient.cups;
      this.electricityOrigin = newClient.electricityOrigin;
      this.gasCups = newClient.cupsGas;
      this.gasOrigin = newClient.gasOrigin;
      this.leadForm = new Lead(
        newClient.lead.firstName,
        newClient.lead.lastName,
        newClient.lead.email,
        newClient.lead.phone,
        null,
        newClient.lead.city,
        newClient.lead.province,
        newClient.lead.address,
        newClient.lead.number,
        newClient.lead.portal,
        newClient.lead.stair,
        newClient.lead.floor,
        newClient.lead.door,
        newClient.lead.CUPS
      );
      if (newClient.addressInfo) {
        this.addressInfo = {
          address: newClient.addressInfo.direccionps_print,
          postalCode: newClient.addressInfo.cpps,
          location: newClient.addressInfo.poblacionps,
          province: newClient.addressInfo.provinciaps
        };
      }
      this.offersGas = newClient.offers.offersGas;
      this.offers =
        newClient.offers.offers !== null ? newClient.offers.offers : [];

      const ofertasLuz = newClient.offers.offers !== null ? newClient.offers.offers : [];

        let ofertaFlexiUno;
              let ofertaFijo;
              let ofertaHoy;
              let ofertaSimple;

            if (ofertasLuz) {
              ofertaFlexiUno = ofertasLuz.filter( offer => offer.producto === "FLEXI UNO");
              ofertaFijo = ofertasLuz.filter( offer => offer.producto === "FIJO");
              ofertaHoy = ofertasLuz.filter(offer => offer.producto === "FLEXI LUZ HOY");
              ofertaSimple = ofertasLuz.filter(offer =>offer.producto === "LUZ SIMPLE");
            }

            this.offersFlexi =  ofertaFlexiUno;

            console.log("IMPRIMO FIJO");
            console.log(ofertaFijo)
            this.offersOne = ofertaFijo;
            console.log(this.offersSimple);

            this.offersHoy = ofertaHoy;
            this.offersSimple = ofertaSimple;

            
        // this.offers.array.forEach(element => {
        //       if(element.producto == "FLEXI UNO"){
        //         this.offersFlexi = element;
        //       }else if(element.producto == "FIJO"){
        //         this.offersOne = element; 
        //       }else if(element.producto == "FLEXI LUZ HOY"){
        //         this.offersHoy = element; 
        //       }else if(element.producto == "LUZ SIMPLE"){
        //         this.offersSimple = element; 
        //       }
        //     });

    },
    printOffers() {
      saveAs(this.base64ToBlob(this.contractResponse.base64), "Ofertas.pdf");
    },
    clearInfo() {
      localStorage.removeItem("newClient");
    },
    cancelButton() {
      this.showModal = false;
      setTimeout(() => {
        this.goRoute("new-client");
      }, 100);
    },
    acceptButton() {
      if (
        this.contentModal ===
        "Se ha producido un error. Por favor intentelo más tarde o pongase en contacto con el soporte técnico"
      ) {
        this.clearInfo();
        this.cancelButton();
      }
      this.showModal = false;
      this.titleModal = "";
      this.contentModal = "";
    },
    checkOffers() {
      if (
        this.offers &&
        this.offers.length > 0 &&
        !this.checkFlexi &&
        !this.checkFlexiOne && 
        !this.checkHoy &&
        !this.checkSimple
      ) {
        this.contentModal = "Es obligatorio seleccionar al menos una oferta de luz";
        this.showModal = true;
        return true;
      } else if (
        this.offers &&
        this.offers.length === 0 &&
        this.offersGas &&
        !this.checkFlexiGAS &&
        !this.checkGasHoy &&
        !this.checkGasSimple
      ) {
        this.contentModal = "Es obligatorio seleccionar la oferta de gas";
        this.showModal = true;
        return true;
      }

      return false;
    },
    prueba(){
      console.log("Prueba");
    },
    sendOffers() {
      if (this.checkFlexi || this.checkFlexiOne || this.checkHoy || this.checkSimple) {
        if (this.checkOffers()) return;
        const loadingInstance = Loading.service({ fullscreen: true });
        ContractService.navigateToContract({
          electricityCups: this.electricityCups,
          gasCups: this.gasCups
        })
          .then(response => {
            const offer = {
              electricityCups:
                this.getFlexiOffer() || this.getFijoOffer() || this.getHoyOffer() || this.getSimpleOffer()
                  ? response.data.data.electricityCups
                  : null,
              flexiOffer: this.getFlexiOffer(),
              fijoOffer: this.getFijoOffer(),
              hoyOffer: this.getHoyOffer(),
              simpleOffer: this.getSimpleOffer(),
              gasOffer: this.getGasOffer(),
              gasHoyOffer: this.getGasHoyOffer(),
              gasSimpleOffer: this.getGasSimpleOffer(),
              optimizedOfferPower: this.selectedOptimizedOfferPower,
              leadSource: this.offers[0].campana,
              gasCups: response.data.data.gasCups,
              checkEnergiaVerde: this.checkEnergiaVerde,
              personalInfo: {
                name: this.leadForm.firstName,
                lastName: this.leadForm.lastName,
                email: this.leadForm.email,
                phone: this.leadForm.phone,
              },
              addressInfo: {
                location: this.getLocation(),
                province: this.getProvince(),
                postalCode: this.getPostalCode(),
                address: this.getAddress(),
                number: this.getNumber(),
                portal: this.getPortal(),
                stair: this.getStair(),
                floor: this.getFloor(),
                door: this.getDoor()
              }
            };
            localStorage.setItem("offer", JSON.stringify(offer));
            loadingInstance.close();
            this.$router.push("/contract");
          })
          .catch(error => {
            loadingInstance.close();
            console.log(error);
          });
      }else if(this.checkFlexiGAS || this.checkGasHoy || this.checkGasSimple){
        if (this.checkOffers()) return;
        const loadingInstance = Loading.service({ fullscreen: true });
        ContractService.navigateToContract({
          electricityCups: this.electricityCups,
          gasCups: this.gasCups
        })
          .then(response => {
            const offer = {
              electricityCups:
                this.getFlexiOffer() || this.getFijoOffer() || this.getHoyOffer() || this.getSimpleOffer()
                  ? response.data.data.electricityCups
                  : null,
              flexiOffer: this.getFlexiOffer(),
              fijoOffer: this.getFijoOffer(),
              simpleOffer: this.getSimpleOffer(),
              hoyOffer: this.getHoyOffer(),
              gasOffer: this.getGasOffer(),
              gasHoyOffer: this.getGasHoyOffer(),
              gasSimpleOffer: this.getGasSimpleOffer(),
              optimizedOfferPower: this.selectedOptimizedOfferPower,
              leadSource: this.offersGas[0].campana,
              gasCups: response.data.data.gasCups,
              checkEnergiaVerde: this.checkEnergiaVerde,
              personalInfo: {
                name: this.leadForm.firstName,
                lastName: this.leadForm.lastName,
                email: this.leadForm.email,
                phone: this.leadForm.phone,
              },
              addressInfo: {
                location: this.getLocation(),
                province: this.getProvince(),
                postalCode: this.getPostalCode(),
                address: this.getAddress(),
                number: this.getNumber(),
                portal: this.getPortal(),
                stair: this.getStair(),
                floor: this.getFloor(),
                door: this.getDoor()
              }
            };
            localStorage.setItem("offer", JSON.stringify(offer));
            loadingInstance.close();
            this.$router.push("/contract");
          })
          .catch(error => {
            loadingInstance.close();
            console.log(error);
          });
      } else {
        this.contentModal = "Tiene que seleccionar al menos una oferta de luz";
        this.showModal = true;
      }
    },
    getAddress() {
      if (this.addressInfo && this.addressInfo.address) {
        return this.addressInfo.address;
      }
      if (this.leadForm && this.leadForm.address) {
        return this.leadForm.address;
      }

      if(this.newClient.offers.offers != null ){
        return this.newClient.offers.offers[0].addressStreet;
      }else if(this.newClient.offers.offersGas != null){
        return this.newClient.offers.offersGas[0].addressStreet;
      }
    },
    getLocation() {
      if (this.addressInfo && this.addressInfo.location) {
        return this.addressInfo.location;
      }
      if (this.leadForm && this.leadForm.city) {
        return this.leadForm.city;
      }
      if(this.newClient.offers.offers != null ){
        return this.newClient.offers.offers[0].addressCity;
      }else if(this.newClient.offers.offersGas != null){
        return this.newClient.offers.offersGas[0].addressCity;
      }
      
    },
    getProvince() {
      if (this.addressInfo && this.addressInfo.location) {
        return this.addressInfo.location;
      }
      if (this.leadForm && this.leadForm.city) {
        return this.leadForm.city;
      }

      if(this.newClient.offers.offers != null ){
        return this.newClient.offers.offers[0].addressState;
      }else if(this.newClient.offers.offersGas != null){
        return this.newClient.offers.offersGas[0].addressState;
      }

    },
    getPostalCode() {
      if (this.addressInfo && this.addressInfo.postalCode) {
        return this.addressInfo.postalCode;
      }
      if (this.leadForm && this.leadForm.postalCode) {
        return this.leadForm.postalCode;
      }
      
      if(this.newClient.offers.offers != null ){
        return this.newClient.offers.offers[0].addressPostalCode;
      }else if(this.newClient.offers.offersGas != null){
        return this.newClient.offers.offersGas[0].addressPostalCode;
      }
    },
    getNumber() {
      if (this.addressInfo && this.addressInfo.number) {
        return this.addressInfo.number;
      }
      if (this.leadForm && this.leadForm.number) {
        return this.leadForm.postalCode;
      }

      if(this.newClient.offers.offers != null ){
        return this.newClient.offers.offers[0].addressNumVia;
      }else if(this.newClient.offers.offersGas != null){
        return this.newClient.offers.offersGas[0].addressNumVia;
      }
    },

    getPortal() {
      if (this.addressInfo && this.addressInfo.portal) {
        return this.addressInfo.portal;
      }
      if (this.leadForm && this.leadForm.portal) {
        return this.leadForm.portal;
      }

      if(this.newClient.offers.offers != null ){
        return this.newClient.offers.offers[0].addressBloque;
      }else if(this.newClient.offers.offersGas != null){
        return this.newClient.offers.offersGas[0].addressBloque;
      }
      
    },
    getStair() {
      if (this.addressInfo && this.addressInfo.stair) {
        return this.addressInfo.stair;
      }
      if (this.leadForm && this.leadForm.stair) {
        return this.leadForm.stair;
      }

      if(this.newClient.offers.offers != null ){
        return this.newClient.offers.offers[0].addressEscalera;
      }else if(this.newClient.offers.offersGas != null){
        return this.newClient.offers.offersGas[0].addressEscalera;
      }
      
    },
    getFloor() {
      if (this.addressInfo && this.addressInfo.floor) {
        return this.addressInfo.floor;
      }
      if (this.leadForm && this.leadForm.floor) {
        return this.leadForm.floor;
      }
      if(this.newClient.offers.offers != null ){
        return this.newClient.offers.offers[0].addressPiso;
      }else if(this.newClient.offers.offersGas != null){
        return this.newClient.offers.offersGas[0].addressPiso;
      }
      
    },
    getDoor() {
      if (this.addressInfo && this.addressInfo.door) {
        return this.addressInfo.door;
      }
      if (this.leadForm && this.leadForm.door) {
        return this.leadForm.door;
      }
      if(this.newClient.offers.offers != null ){
        return this.newClient.offers.offers[0].addressPuerta;
      }else if(this.newClient.offers.offersGas != null){
        return this.newClient.offers.offersGas[0].addressPuerta;
      }
    },
    getFlexiOffer() {
      if (this.checkFlexi) {
        return this.offersFlexi[0];
      } else {
        return null;
      }
    },
    getFijoOffer() {
      if (this.checkFlexiOne) {
        return this.offersOne[0];
      } else {
        return null;
      }
    },
    getSimpleOffer() {
      if (this.checkSimple) {
        return this.offersSimple[0];
      } else {
        return null;
      }
    },
    getHoyOffer() {
      if (this.checkHoy) {
        return this.offersHoy[0];
      } else {
        return null;
      }
    },
    getGasOffer() {
      if (this.checkFlexiGAS) {
        return this.offersFlexiGas[0];
      }else {
        return null;
      }
    },
    getGasSimpleOffer(){
      if(this.checkGasSimple){
        return this.offersGasSimple[0];
      }else{
        return null
      } 
    },
    getGasHoyOffer() {
      if(this.checkGasHoy){
        return this.offersGasHoy[0];
      }else{
        return null;
      }
    },
    calculateCuota(offer) {
      let value = null;
      let firstValue = (offer.cac_electricidad / 12) * offer.luzp1cimp;
      let secondValue =
        offer.p_contratada_electricidad * offer.potenciap1cimp +
        offer.contadorcimp;

      firstValue = firstValue.toFixed(2);
      secondValue = secondValue.toFixed(2);
      value = parseFloat(firstValue) + parseFloat(secondValue);
      value = Math.round(value).toString();
      return value;
    },
    formatFixed(obj, param, value, fixed) {
      if (
        Number.isInteger(value) ||
        (typeof value === "string" && value.includes(","))
      )
        return value;

      if (value) {
        const result = parseFloat(value).toFixed(fixed);
        if (obj === "flexi") {
          if( this.offersFlexi[0]!= null &&  this.offersFlexi[0][param] != null){
            this.offersFlexi[0][param] = result;
          }
        } else if (obj === "one") {
          if(this.offersOne[0] != null && this.offersOne[0][param] != null){
            this.offersOne[0][param] = result;
          }
        } else if(obj === "hoy"){
          if(this.offersHoy[0] != null && this.offersHoy[0][param] != null){
            this.offersHoy[0][param] = result;
          }
        }else if(obj === "simple"){
          if(this.offersSimple[0] != null && this.offersSimple[0][param] != null){
            this.offersSimple[0][param] = result;
          }
        }else if(obj === "flexigas"){
          if(this.offersGas[0] != null && this.offersGas[0][param] != null){
            this.offersGas[0][param] = result;
          }
        }else if(obj === "gashoy"){
          if(this.offersGasHoy[0] != null && this.offersGasHoy[0][param] != null){
            this.offersGasHoy[0][param] = result;
          }
        }else if(obj === "gassimple"){
          if(this.offersGasSimple[0] != null && this.offersGasSimple[0][param] != null){
            this.offersGasSimple[0][param] = result;
          }
        }else {
          this.offersGas[0][param] = result;
        }
        return result.replace(".", ",");
      }
    },
    roundValue(obj, param, value) {
      if (value) {
        //const result = Math.round(value);
        const result = value;
        if (obj === "flexi") {
          this.offersFlexi[0][param] = result;
        } else if (obj === "one") {
          this.offersOne[0][param] = result;
        }else if(obj === "hoy"){
          this.offersHoy[0][param] = result;
        }else if(obj === "simple"){
          this.offersSimple[0][param] = result;
        } else {
          this.offersGas[0][param] = result;
        }
        return result;
      }
    },
    formatDate(value) {
      if (value) {
        return moment(value).format("YYYY-MM-DD");
      }
      return "";
    },
    base64ToBlob(base64) {
      const binary = atob(base64.replace(/\s/g, ""));
      const buffer = new ArrayBuffer(binary.length);
      const view = new Uint8Array(buffer);
      for (let i = 0; i < binary.length; i++) {
        view[i] = binary.charCodeAt(i);
      }

      return new Blob([view], { type: "application/pdf" });
    },
    goRoute(route) {
      if (route) {
        this.$router.push({ name: route });
      } else {
        this.$router.go();
      }
    }
  }
};
</script>

<style lang="scss">
@import "src/assets/sass/styles";
#new-client {
  width: 100%;
  height: auto;
  .separated {
    height: 1px;
    margin: 0px 50px;
    background: $grey-dark-color;
  }
  .box {
    display: inline-flex;
    background: $white-color;
    width: 100%;
    border: 1px solid #e8e8e8;
    padding: 50px;
    align-items: center;
    &.borderTop {
      border-top: none;
    }
    &.borderBottom {
      border-bottom: none;
    }
    .checkbox {
      margin-right: 50px;
    }
    .price-offer,
    .info-offer {
      display: inline-block;
      .variable {
        display: block;
        width: fit-content;
        width: -moz-fit-content;
        span {
          font-size: 20px;
        }
        div {
          width: fit-content;
          width: -moz-fit-content;
        }
      }
      .title {
        font-size: 24px;
      }
      span {
        color: $pink-color;
        font-size: 28px;
        font-weight: 300;
        strong {
          color: $pink-color;
          font-weight: 600;
        }
        &.small {
          font-size: 22px;
        }
      }
    }
    .info-offer {
      label {
        display: block;
        font-weight: 400;
        font-size: 18px;
        strong {
          font-weight: 600;
        }
      }
      .block {
        i {
          color: $white-color;
          font-size: 12px;
          background: $pink-color;
          border-radius: 50%;
          padding: 2px;
          height: 16px;
          width: 16px;
          margin-right: 10px;
        }
      }
    }
  }
  .buttons {
    display: flex;
    justify-content: flex-end;
    #order1 {
      order: 1;
    }
    #order2 {
      order: 2;
    }
  }

  .calculator-modal-button {
    padding: 20px 0px 20px 0px;
    border: 1px solid #e0d7d7;
    border-radius: 25px 25px 0 0;
    cursor: pointer;
    background: white;

    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-evenly;
    align-items: center;
    width: 335px;

    span {
      color: #ec1d99 !important;
      font-size: 22px;
    }
  }

  @media (max-width: 1000px) {
    .calculator-modal-button {
      width: 100%;
    }
  }

  @media (max-width: 360px) {
    .calculator-modal-button {
      span {
        font-size: 1rem;
      }
    }
  }
}

.switch-offers-title {
  font-weight: 500 !important;
}

.switch-offers-label {
  color: #777777 !important;
  font-weight: 500 !important;
  font-size: 18px !important;
  overflow-wrap: normal !important;
}

.calc-form {
  padding: 15px 30px 30px 30px;
  background: #f7f7f7;
}
.calc-modal-title {
  font-size: 34px !important;
  font-weight: 700 !important;
}

.calc-modal-text {
  font-size: 18px !important;
  color: #939393 !important;
}

.calc-modal-text-bold {
  font-weight: bold;
  color: black;
}

.calc-modal-item-form-label {
  color: #2e2e2e;
  line-height: normal;
  padding-top: 10px;
}

.calc-modal-slider-container {
  display: inline-flex;
  margin-left: 15px;
  line-height: 30px;
}

.calc-modal-info-container {
  width: 90%;
  margin: 0 auto;
}

.calc-modal-info-title {
  font-size: 2rem;
  color: black;
  line-height: 1.9rem;
}

.calc-modal-info-price {
  color: #ff267c;
  font-weight: bold;
  font-size: large;
}

.calc-modal-info-bold {
  font-weight: bold;
  color: black;
  font-size: medium;
}

.calc-modal-info-normal {
  font-size: large;
  color: #2c2c2c;
  line-height: normal;
}

.custom-icon {
  font-size: 2rem;
  color: #ff1e7a;
  margin-left: 15px;
}

/*
.calculator-modal-button {

}*/

@media (max-width: 1200px) {
  .calc-modal-info-container {
    width: 50%;
    margin-top: 20px;
  }
}

@media (max-width: 1080px) {
  .calc-modal-info-price {
    font-size: medium;
  }
}

@media (max-width: 768px) {
  .calc-modal-info-container {
    width: 65%;
    margin-top: 20px;
  }

  .calculator-modal-button {
    margin-left: 0;
  }
}

@media (max-width: 576px) {
  .calc-modal-info-container {
    width: 100%;
    margin-top: 20px;
  }

  .calc-modal-item-form-label {
    padding-top: 0;
  }
}

@media (max-width: 1530px) {
  #new-client {
    .box {
      .price-offer,
      .info-offer {
        span,
        label {
          font-size: 16px !important;
          &.small {
            display: block;
            font-size: 16px;
          }
        }
      }
    }
  }
}

@media (max-width: 1255px) {
  #new-client {
    .box {
      padding: 50px 20px;
      .checkbox {
        margin-right: 20px;
      }
      .price-offer {
        .title {
          font-size: 20px;
        }
      }
    }
  }
}

@media (max-width: 991px) {
  #new-client {
    .box {
      padding: 50px;
      .checkbox {
        margin-right: 50px;
      }
      .price-offer {
        margin-bottom: 20px;
      }
      .price-offer,
      .info-offer {
        label {
          font-size: 18px;
          margin: 0;
          display: block;
        }
      }
      .info-offer {
        span {
          font-size: 21px;
        }
      }
    }
    .return {
      margin-bottom: 20px;
    }
  }
}

@media (max-width: 800px) {
  .buttons {
    display: block !important;
  }
}

@media (max-width: 767px) {
  #new-client {
    .address {
      margin-top: 1rem;
    }
  }
}

@media (max-width: 650px) {
  #new-client {
    .box {
      display: inline-block;
      padding: 50px 25px;
      .checkbox {
        margin-bottom: 25px;
      }
      .price-offer,
      .info-offer {
        margin-top: 25px;
        span {
          font-size: 18px !important;
          line-height: 20px;
        }
      }
    }
  }
}

@media (max-width: 459px) {
  #new-client {
    .switch-offers {
      margin-top: 0.75rem;
      text-align: center !important;
    }
    .address {
      text-align: center !important;
      span {
        font-size: 15px;
      }
    }
    .box {
      .price-offer,
      .info-offer {
        label,
        span {
          font-size: 15px !important;
        }
      }
    }
  }
}
</style>
